import HeaderSection from './components/HeaderSection';
import HeroSection from './components/HeroSection';
import MenuSection from './components/MenuSection';
import SpaceSection from './components/SpaceSection';
import AccessSection from './components/AccessSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <main className="font-sans-jp bg-cream-warm">
      <HeaderSection />
      <HeroSection />
      <MenuSection />
      <SpaceSection />
      <AccessSection />
      <ContactSection />
    </main>
  );
}
